var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.9 19.6",
    style: {
      enableBackground: "new 0 0 15.9 19.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20380",
    d: "M9.4,14.6H2.5c-0.3-0.1-0.5-0.2-0.8-0.3c-0.5-0.4-0.8-1-0.7-1.6C1,10,1,7.3,1,4.5c0-0.1,0-0.2-0.1-0.2 c-0.7-0.3-1-1-0.7-1.7c0.2-0.5,0.7-0.8,1.3-0.8c0.5,0,1,0,1.5,0c0,0,0.1,0,0.2,0c0-0.1,0-0.3,0-0.4C3,0.7,3.6,0,4.3,0c0,0,0,0,0,0 c1,0,2.1,0,3.1,0c0.7,0,1.3,0.6,1.3,1.3c0,0.2,0,0.3,0,0.5h1.7c0.4,0,0.8,0.2,1.1,0.5c0.2,0.2,0.3,0.5,0.3,0.8v0.2c0,0,0,0.1,0,0.1 c-0.1,0.5-0.4,0.8-0.8,1c-0.1,0-0.2,0.1-0.1,0.2c0,2.7,0,5.4,0,8.1c0,0.1,0,0.3,0,0.4c-0.1,0.7-0.6,1.3-1.3,1.5 C9.5,14.6,9.4,14.6,9.4,14.6 M1.7,4.4v0.1c0,2.7,0,5.5,0,8.2c0,0.1,0,0.2,0,0.3c0.1,0.5,0.5,0.9,1,0.9c2.1,0,4.3,0,6.4,0 c0.3,0,0.5-0.1,0.7-0.3c0.3-0.3,0.4-0.6,0.4-1c0-2.7,0-5.4,0-8.2V4.4H1.7z M5.9,3.7h4.5c0.1,0,0.1,0,0.2,0c0.3,0,0.6-0.3,0.5-0.7 c0-0.2-0.2-0.4-0.4-0.5c-0.1,0-0.2,0-0.3,0c-3,0-6,0-9,0c-0.1,0-0.2,0-0.2,0c-0.3,0-0.5,0.3-0.5,0.6c0,0.3,0.2,0.5,0.4,0.6 c0.1,0,0.2,0,0.3,0C2.9,3.7,4.4,3.7,5.9,3.7 M8.1,1.8c0-0.2,0-0.3,0-0.5c0-0.4-0.3-0.6-0.7-0.6c0,0,0,0,0,0c-0.3,0-0.6,0-0.8,0 c-0.7,0-1.4,0-2.2,0c-0.3,0-0.6,0.2-0.7,0.5c0,0.2,0,0.4-0.1,0.6H8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20381",
    d: "M4.3,8.9c0,1,0,2.1,0,3.1c0,0,0,0.1,0,0.1c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.4-0.3 c0-0.1,0-0.1,0-0.2c0-2.1,0-4.2,0-6.3c0-0.3,0.1-0.5,0.4-0.4c0.2,0,0.3,0.2,0.3,0.3c0,0.1,0,0.3,0,0.4C4.3,7,4.3,7.9,4.3,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20382",
    d: "M5.6,8.9c0-1.1,0-2.1,0-3.2c0-0.3,0.1-0.4,0.3-0.4c0.2,0,0.3,0.1,0.3,0.3c0,0.1,0,0.1,0,0.2 c0,2.1,0,4.2,0,6.2c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.3-0.4,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2C5.6,11,5.6,9.9,5.6,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20383",
    d: "M7.6,8.9c0-1,0-2.1,0-3.1c0-0.3,0.1-0.5,0.3-0.5s0.4,0.2,0.4,0.5c0,2.1,0,4.2,0,6.2c0,0.3-0.1,0.5-0.4,0.5 S7.6,12.3,7.6,12C7.6,11,7.6,9.9,7.6,8.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.2f3bf499f444bee30203333e5731cdf7.svg";
export { ForwardRef as ReactComponent };